export default "__VITE_ASSET__JY5EUGsl__"